import { parse } from 'node-html-parser';

export const useHtmlUtils = () => {
    const stripHtml = (html) => {
        if (!html) return '';
        
        if (process.client && typeof document !== 'undefined') {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            return tempDiv.textContent || tempDiv.innerText || '';
        }
        
        const root = parse(html);
        return root.textContent;
    };
    
    const hasHtmlContent = (html) => {
        const stripped = stripHtml(html);
        return stripped.trim().length > 0;
    };
    
    return {
        stripHtml,
        hasHtmlContent
    };
};
